import React from 'react';
import styled from 'styled-components';
import {LockOutlined} from "@ant-design/icons";

const StyledWarningOutlined = styled(LockOutlined)`
  margin-left: 4px;
  font-size: 16px;
  color: rgba(255, 163, 158, 76%) !important;
  
  &.grey {
    color: rgba(0,0,0,15%) !important;
  }
`;

export function LockIcon(props) {
    const { className } = props;
    return <StyledWarningOutlined className={`subscription-lock-icon ${className || ""}`} />;
}
